import type { TFunction } from 'i18next'

export type MarketingTranslator = TFunction<'marketing'>
export type MarketingLanguage = 'ko' | 'en'
export const MARKETING_LANGUAGE_KEY = 'lc-marketing-language'

export function resolveMarketingLanguage(search: string, saved: string | null): MarketingLanguage {
  const requested = new URLSearchParams(search).get('lang')
  if (requested === 'ko' || requested === 'en') return requested
  return saved === 'en' ? 'en' : 'ko'
}

export function readMarketingLanguage(search = window.location.search): MarketingLanguage {
  let saved: string | null = null
  try {
    saved = window.localStorage.getItem(MARKETING_LANGUAGE_KEY)
  } catch {
    // URL selection and the Korean default also work when browser storage is unavailable.
    return resolveMarketingLanguage(search, null)
  }
  return resolveMarketingLanguage(search, saved)
}

export function saveMarketingLanguage(language: MarketingLanguage): void {
  try {
    window.localStorage.setItem(MARKETING_LANGUAGE_KEY, language)
  } catch {
    // The active language remains in memory when browser storage is unavailable.
    return
  }
}
